import Topic from './Topic'
import TopicUser from './TopicUser'
import TopicTitle from './TopicTitle'
import TopicDesc from './TopicDesc'
import TopicButtons from './TopicButtons'
import topicMix from './TopicMix'
export default [
  Topic,
  TopicUser,
  TopicTitle,
  TopicDesc,
  TopicButtons,
  topicMix,
]

